// pages/FollowingFeedPage.tsx
import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { FeedEntryType } from '../../types/FeedEntryType.type';
import RecommendationFeed from '../Feed/recommendationFeed';

const FollowingFeedPage: React.FC = () => {
  const { user } = useAuth();
  const username = user?.username ?? 'You';

  return <RecommendationFeed feedType={FeedEntryType.FOLLOWING} />;
};

export default FollowingFeedPage;
